// extracted by mini-css-extract-plugin
export default {"dialog_overlay":"ImageDialog_dialog_overlay__KiGan","enlarged_image":"ImageDialog_enlarged_image__HttcH","close_button":"ImageDialog_close_button__-vskH"};